// extracted by mini-css-extract-plugin
export default {"section":"SectionWithUnderlineTitle_section__YiPK3","sectionTitle":"SectionWithUnderlineTitle_sectionTitle__iGvU0"};